export default __webpack_public_path__ + "static/media/early-payment-availed-using-ct.10ada25f.svg";